<div>
    <h2 mat-dialog-title>{{dialogData.titleString ? dialogData.titleString : ''}}</h2>
    <!-- MAT-INPUT in case of prompt...-->
    <mat-dialog-content *ngIf="dialogData.dialogType === 1">
        <mat-form-field [ngStyle]="{'width': '100%'}">
            <input matInput placeholder="{{dialogData.placeholderString 
                ? dialogData.placeholderString 
                : MY_CONSTANT.LABEL_INPUT_REQUIRED}}" [formControl]="dialogConfirmationControl" 
                [maxlength]="dialogData.maxLength ? dialogData.maxLength : 254" autocomplete="off" />
            <mat-error *ngIf="dialogConfirmationControl.hasError('required')">
                {{MY_CONSTANT.LABEL_INPUT_REQUIRED}}
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>
    <!-- General text which looks normal, not bold as the title -->
    <mat-dialog-content>
        {{dialogData.messageString}}
    </mat-dialog-content>
    <!-- Drop down as input -->
    <mat-dialog-content *ngIf="dialogData.dialogType === 3">
        <mat-form-field [ngStyle]="{'width': '100%'}">
            <mat-label>Node type</mat-label>
            <mat-select [(value)]="selected" [formControl]="nodeTypeSelectControl">
                <mat-option *ngFor="let data of nodeTypeSelectData" [value]="data.value">{{data.key}}</mat-option>
            </mat-select>
            <mat-error *ngIf="dialogConfirmationControl.hasError('required')">
                {{MY_CONSTANT.LABEL_SELECT_REQUIRED}}
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button tabindex="-1" mat-dialog-close (click)="close()" *ngIf="dialogData.dialogType !== 0">{{dialogData.cancelButtonString ? dialogData.cancelButtonString : 'Cancel'}}</button>
        <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
        <button mat-raised-button tabindex="-1" color='accent' (click)="save()">{{dialogData.okButtonString ? dialogData.okButtonString : 'Done'}}</button>
    </mat-dialog-actions>
</div>